import TemplateFactory from './templateFactory';
import { formatPrice } from '../../../utils/formatPrice';
import $ from 'jquery';
import { UNKNOWN_DATE_KEY } from '../../product/services/productDeliveriesService';
import { generateProductUrl } from '../../product/services/ProductService';

const $fillDeliveryBlock = ($products, fullDate, formattedDate) => {
  const $deliveryTemplate = TemplateFactory.deliveryBlock()
  let uuid = formattedDate || fullDate;

  const titleHtml = fullDate === UNKNOWN_DATE_KEY
    ? 'Срок уточняется'
    : `Доставка ${formattedDate}`
  $deliveryTemplate.find('.cart-group-title').html(titleHtml)

  $deliveryTemplate.find('.cart-group')
    .toggleClass('hidden', $products.filter( p => p.find('.product-item.d-none').length == 0 ).length == 0 )

  $products.map($product => {
    $deliveryTemplate.find('.product-list').append($product.html())
    uuid += 'id' + $product.find('[data-id]').attr('data-id');

    $deliveryTemplate.find('.accordion')
      .attr('data-hash', hashString( uuid ))
      .attr('data-fulldate', fullDate )
      .css('--delivery-date', fullDate );
  })

  return $deliveryTemplate
}

const $fillProductQuantity = e => {
  let elInput = $(e.target);

  const allowed = [
    'Backspace', 'Delete', 'Enter',
    'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
    'Tab',
  ];

  let allowedCombo = e.ctrlKey && e.which === 65;

  if (e.type == 'keydown') {
    if( ! allowedCombo && ! allowed.includes(e.key) && !/^\d$/.test(e.key)) {
      e.preventDefault()
      return false;
    }

    if (e.key === 'Enter' || e.which === 13) {
      elInput.blur();
      return true;
    }
  } else if ( e.type == 'blur' || e.type == 'focusout' ) {
    return true;
  }

  return false;
}


const $fillProduct = (product, pageType, deliveryDate) => {

  const $productTemplate = pageType == 'checkout' ? 
    TemplateFactory.checkoutProductBlock() : TemplateFactory.cartProductBlock();

  const $quantityLabel = $productTemplate.find('.product-item-quantity-label');
  const $quantityGroup = $productTemplate.find('.product-item-quantity');  
  const $quantityInput = $quantityGroup.find('input');
  const $quantityButtonMinus = $quantityGroup.find('.icon-minus');
  const $quantityButtonPlus = $quantityGroup.find('.icon-plus');

  const uom = $quantityInput.attr('data-uom')
  const uomLabel = $quantityLabel.attr('data-uom')
  const randomInt = Math.floor(Math.random() * 999)
  const maxQuantity = typeof product.totalMaxAmount === 'number' && product.totalMaxAmount > 0
    ? product.totalMaxAmount
    : 0;

  const maxQuantityDelivery = typeof product.sliceMaxAmount === 'number' && product.sliceMaxAmount > 0
    ? product.sliceMaxAmount
    : maxQuantity;
  let toDisablePlus = false;
  
  $productTemplate.find( '.product-item' )
    .attr( 'data-id', product.article )
    .attr( 'data-delivery', deliveryDate )
    .attr( 'data-basic', product.isBasic ? 1 : 0 )
    .attr( 'data-order-stock', product.isOrder ? 1 : 0 )
    .toggleClass('d-none', product.amount < 0 )
    .toggleClass('d-flex', product.amount >= 0 );
    
  // ?? '' обязателен: .attr(name, undefined) — no-op, и у товара без imageId
  // (добавлен клиентски: живой поиск/каталог) остался бы чужой data-image-id
  // из шаблона-клона — лоадер отрисовал бы картинку другого товара.
  $productTemplate.find('.product-item-image img')
    .attr('data-image-id', product.imageId ?? '' )
    .attr('id', product.imageId != null ? 'img-' + product.imageId : '' )
  
  $productTemplate.find('.product-item-name .btn, .product-item-meta .btn')
    .attr( 'data-btn-copy', product.article )
    .text( product.article );   

  $productTemplate.find('[data-button-favorite]')
    .attr('data-button-favorite', product.id )    
    .toggleClass('active', !!product.hasFavorites );


  let elPriceMain = $productTemplate.find('.product-item-price_main');
  let bestPrice = elPriceMain.siblings('.product-item-price_best');
  let oldPrice =  elPriceMain.siblings('.product-item-price_old')
  // TODO: fake best price label to remove
  if (product.priceType === 'best' && product.bestPrice > 0) {
      bestPrice.html( formatPrice( product.bestPrice * product.amount ));
      $productTemplate.find('.product-item-price_single_text').html( formatPrice( product.bestPrice ));
      oldPrice.remove();
  } else {
      $productTemplate.find('.product-item-price_single_text').html( formatPrice( product.price ));
      oldPrice.html( formatPrice( product.price * product.amount ))
      bestPrice.remove();
  }

  if (product.oldPrice <= 0) {
    oldPrice.remove();
  }



  $productTemplate.find('.product-item-name_text').html(product.name);

  elPriceMain.html( formatPrice( product.oldPrice * product.amount ))
  if( product.quantityStep > 1 ) {
    $productTemplate.find('.product-item-step').html( `${product.quantityStep}&nbsp;${uom}` )
  } else {
    $productTemplate.find('.product-item-step').parent().remove();
  }

  if( typeof product.url != 'undefined' ) {
    $productTemplate.find('.product-link').attr('href', product.url );
  }

  $quantityInput.attr('value', `${product.amount} ${uom}`);
  $quantityInput.attr('data-step', product.quantityStep );

  $quantityLabel.text( `${product.amount} ${uomLabel}` );
  
  if( maxQuantity > 0 ) {
    $quantityInput.attr('data-max', maxQuantity );
    $quantityInput.attr('title', `Максимум ${maxQuantity} шт.` );  
    toDisablePlus = product.amount >= maxQuantity;
  }

  if( maxQuantityDelivery > 0 ) {
    $quantityInput.attr('data-max-delivery', maxQuantityDelivery );
    /*if( ! product.isBasic ) {      
      toDisablePlus = product.amount >= maxQuantityDelivery;
    }*/
  }


  $quantityButtonMinus.prop('disabled', product.amount <= 0 );
  $quantityButtonPlus.prop('disabled', toDisablePlus );

  product.amount > 0 && $quantityGroup.addClass('active');

  $productTemplate.find('.form-check-input').attr('checked', product.isActive)

  $productTemplate.find('.form-check-input').
    attr('id', 'cart-item-' + product.article + '-' + randomInt)
  $productTemplate.find('.product-item-image').
    attr('for', 'cart-item-' + product.article + '-' + randomInt)
  $productTemplate.find('.product-item-name label').
    attr('for', 'cart-item-' + product.article + '-' + randomInt)

  !product.isBasic &&
  $productTemplate.find('.form-check-input').attr('disabled', 'disabled')

  return $productTemplate
}

const $fillOutOfStockProduct = (cart) => {
  const $template = TemplateFactory.outOfStockProductBlock()
  const product = cart.product

  const productImages = Array.isArray(product.images) ? product.images : []
  const images = [...productImages].sort((a, b) => a.position - b.position)
  const imagePath = images.length
    ? '/uploads/images/original/' + images[0].path
    : '/images/technosuccess-placeholder.svg'

  const productName = (Array.isArray(product.descriptions) && product.descriptions[0] && product.descriptions[0].name)
    ? product.descriptions[0].name
    : (product.name || '')

  const productUrl = generateProductUrl(product.id)

  $template.find('.product-item')
    .attr('data-id', product.productCode)
    .attr('data-amount', cart.amount)

  $template.find('.product-item-image img')
    .attr('src', imagePath)
    .attr('data-imageid', images.length ? images[0].path : '')

  $template.find('.product-item-name_text').html(productName)

  $template.find('[data-btn-copy]')
    .attr('data-btn-copy', product.productCode)
    .text(product.productCode)

  $template.find('[data-button-favorite]')
    .attr('data-button-favorite', product.id)
    .toggleClass('active', !!product.hasFavorites)

  $template.find('.product-item-price_main').html(formatPrice(cart.price))

  $template.find('.product-link').attr('href', productUrl)

  return $template
}

const $fillWidgetProduct = (product) => {

  const $widgetProductTemplate = TemplateFactory.widgetProduct();
  const $widgetProductImage = $widgetProductTemplate.find('.product-item-image img');
  const loadedImage = getLoadedCartImage( product.imageId );
  loadedImage.src ? 
    $widgetProductImage
      .attr('src', loadedImage.src)
      .attr('srcset', loadedImage.srcset)
      .attr('data-processed', 'true') :   
    $widgetProductImage
      .attr('data-image-id', product.imageId ?? '')
      .attr('id', product.imageId != null ? 'img-' + product.imageId : '')

  $widgetProductTemplate.attr('data-id', product.article);  
    
  $widgetProductTemplate.find('.product-item-name_text')
    .html( product.name );
  
  $widgetProductTemplate.find('[data-button-compare]')
    .attr( 'data-button-compare', product.id ).toggleClass('active', compareProductIds.includes( product.id ));

  $widgetProductTemplate.find('.product-item-price_main').
    html( formatPrice( product.priceType === 'best' ? product.bestPrice : product.price * product.amount ));
  if (product.priceType === 'best') {
    $widgetProductTemplate.find('.product-item-price_main').addClass('label_post-best_price');
  }

  $widgetProductTemplate.find('.product-item-price span').
    html( product.amount + ' шт.' );

  $widgetProductTemplate.find('[name="quantity"]').val( product.amount );

  if( typeof product.url != 'undefined' ) {
    $widgetProductTemplate.find('.product-link').attr('href', product.url );
  }
   
  return $widgetProductTemplate;
}

const fillDeliveryAddress = contractor => {
  const deliveryLocation = contractor.deliveryLocations[0]

  $('#address_delivery').
    attr('placeholder', deliveryLocation.city.name)

  $('#pickup_city').
    attr('placeholder', deliveryLocation.city.name)

  $('#delivery_address').
    attr('placeholder', deliveryLocation.address)
}

const getLoadedCartImage = imageId => {

    const imgAttributes = {src: null, srcset : null};

    // Без guard'а imageId=undefined собрал бы селектор [data-image-id="undefined"],
    // а пустой jQuery-набор truthy — проверять нужно .length.
    if( imageId == null ) {
      return imgAttributes;
    }

    const elLoadedImage = $(`[data-image-id="${imageId}"][data-processed="true"]` ).first();
    if( elLoadedImage.length ) {
      imgAttributes.src = elLoadedImage.attr('src');
      imgAttributes.srcset = elLoadedImage.attr('srcset');
    }

    return imgAttributes;
}

const hashString = (str) => {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) + hash) + str.charCodeAt(i);
  }
  return (hash >>> 0).toString( 16 );
}

const fillOrderConditions = ({
  amount,
  height,
  length,
  price,
  weight,
  width,
}) => {

  const $order = $('#order')
  const emptyOrder = amount <= 0;
  $order.find('.cart-total').toggleClass( 'mt-lg-3', ! emptyOrder )
  $order.find('.cart-total-value, .cart-move-cost').html( formatPrice( price ) )
  $order.find('.cart-summary-item-value').
    html( emptyOrder ? '&nbsp;' : formatPrice( price ) );

  $order.find('.cart-summary-discount').toggleClass('d-none', emptyOrder );
  $order.find('#countProducts').html( emptyOrder ? "нет" : amount );
  $order.find('#btn_create_order').prop('disabled', emptyOrder );

  $('#cart-confirm .btn[href]').toggleClass('disabled', emptyOrder );

  let dimensions = '';

  if( ! emptyOrder ) {
    if( weight > 0 )
      dimensions += `${weight} кг`;
    if( height > 0 && length > 0 && width > 0 )
      dimensions += ` • ${height * length * width} м. куб.`;  
  }
  
  $order.find('.cart-summary-note').html( dimensions || '' );
}

const fillContractorsInMoveProducts = (contractors) => {
  contractors.forEach(contractor => {
    $('#move_counterparty').append(
      `<option value="${contractor.contractorId}">${contractor.name}</option>`,
    )
  })
}

const fillSummaryInMoveProducts = ({ amount, price }) => {
  const $form = $('#cart_move_form')

  $form.find('.cart-move-quantity').html( amount > 0 ? amount + ` товаров` : 'нет выбранных товаров' );
  $form.find('.cart-move-cost').html( price > 0 ? formatPrice( price ) : '&nbsp;' );
}

const fillFloatingConfirm = ({ amount, price }) => {
  const elCartConfirm = $('.cart-confirm');

  elCartConfirm.find('.btn').toggleClass('disabled', amount == 0 );
  elCartConfirm.find('.product-item-price_main').html( formatPrice( price ) );
}

export {
  $fillDeliveryBlock,
  $fillProduct,
  $fillOutOfStockProduct,
  $fillWidgetProduct,
  fillOrderConditions,
  $fillProductQuantity,
  fillContractorsInMoveProducts,
  fillSummaryInMoveProducts,
  fillDeliveryAddress,
  fillFloatingConfirm
}
